import React from 'react';
import Styles from './assets/Styles.scss';
import { ButtonList } from './ButtonList';
import { IButtonOverflowItem } from './entities/IButtonOverflowItem';

import classNames from 'classnames/bind';
import { DropdownProps } from 'antd';
const cx = classNames.bind(Styles);

const MeasureChildren = React.forwardRef<
	HTMLDivElement,
	{ items: IButtonOverflowItem[]; dropdownProps?: DropdownProps; visible: boolean }
>((props, ref) => {
	return (
		props.visible && (
			<div
				ref={ref}
				className={cx({ container: true, measureContainer: true })}
			>
				<ButtonList
					items={props.items}
					dropdownProps={props.dropdownProps}
					measureMode
				/>
			</div>
		)
	);
});

export { MeasureChildren };
